/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents displayable metadata about the message sender.
 */
export type SenderMetadataResponse = {
    /**
     * The human-readable name of the sender.
     */
    displayName?: string;
    /**
     * The human-readable role of the sender.
     */
    displayRole?: string;
    /**
     * The role of the sender.
     */
    role?: SenderMetadataResponse.role;
};

export namespace SenderMetadataResponse {

    /**
     * The role of the sender.
     */
    export enum role {
        ANONYMOUS = 'ANONYMOUS',
        CHANGE_PASSWORD = 'CHANGE_PASSWORD',
        API_DOCUMENTATION = 'API_DOCUMENTATION',
        USER = 'USER',
        STAFF_VIEW_ONLY = 'STAFF_VIEW_ONLY',
        STAFF = 'STAFF',
        STAFF_ADMIN_ACCESS = 'STAFF_ADMIN_ACCESS',
        STAFF_CUSTOMER_SUPPORT = 'STAFF_CUSTOMER_SUPPORT',
        STAFF_DIABETES_EDUCATOR = 'STAFF_DIABETES_EDUCATOR',
        STAFF_1099_HEALTH_COACH = 'STAFF_1099_HEALTH_COACH',
        STAFF_PROVIDER = 'STAFF_PROVIDER',
        STAFF_PHYSICIAN = 'STAFF_PHYSICIAN',
        STAFF_PHYSICIAN_ASSISTANT = 'STAFF_PHYSICIAN_ASSISTANT',
        STAFF_NURSE_PRACTITIONER = 'STAFF_NURSE_PRACTITIONER',
        STAFF_KNOWLEDGE_BASE_EDITOR = 'STAFF_KNOWLEDGE_BASE_EDITOR',
        DEVELOPER = 'DEVELOPER',
        TRUSTED_DEVICE = 'TRUSTED_DEVICE',
        SUPER_ADMIN = 'SUPER_ADMIN',
    }


}

